module.exports = __webpack_public_path__ + "static/media/bus-alt.3dfba7be.svg";